var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['archive-lesson', { 'archive-lesson--active': _vm.isActive }]},[_c('h6',{ref:"title",class:[
      'archive-lesson__title',
      { 'archive-lesson__title--hidden': _vm.isTitleHidden },
    ]},[_vm._v(" "+_vm._s(_vm.formatedTitle)+" ")]),_c('ProgressStar',{attrs:{"progress":_vm.progress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }